// Türkiye 81 İl listesi — /app/frontend/public/tr-cities.json GeoJSON'ındaki `properties.name` değerleriyle bire bir uyumludur.
// Bu ad eşleşmesi, dashboard'daki Türkiye haritası ile cari kayıtları arasında bağı kurar.
export const TR_PROVINCES = [
  "Adana","Adıyaman","Afyon","Aksaray","Amasya","Ankara","Antalya","Ardahan","Artvin","Aydın",
  "Ağrı","Balıkesir","Bartın","Batman","Bayburt","Bilecik","Bingöl","Bitlis","Bolu","Burdur",
  "Bursa","Denizli","Diyarbakır","Düzce","Edirne","Elazığ","Erzincan","Erzurum","Eskişehir","Gaziantep",
  "Giresun","Gümüşhane","Hakkari","Hatay","Isparta","Iğdır","Kahramanmaraş","Karabük","Karaman","Kars",
  "Kastamonu","Kayseri","Kilis","Kocaeli","Konya","Kütahya","Kırklareli","Kırıkkale","Kırşehir","Malatya",
  "Manisa","Mardin","Mersin","Muğla","Muş","Nevşehir","Niğde","Ordu","Osmaniye","Rize",
  "Sakarya","Samsun","Siirt","Sinop","Sivas","Tekirdağ","Tokat","Trabzon","Tunceli","Uşak",
  "Van","Yalova","Yozgat","Zonguldak","Çanakkale","Çankırı","Çorum","İstanbul","İzmir","Şanlıurfa","Şırnak"
].sort((a, b) => a.localeCompare(b, "tr"));

// Yaygın yazım farklarını normalize et (kullanıcı serbest metin yazsa da haritayla eşleştirebilelim).
const ALIASES = {
  "afyonkarahisar": "Afyon",
  "urfa": "Şanlıurfa",
  "maraş": "Kahramanmaraş",
  "k.maraş": "Kahramanmaraş",
  "istanbul": "İstanbul",
  "izmir": "İzmir",
  "sanliurfa": "Şanlıurfa",
  "canakkale": "Çanakkale",
  "sirnak": "Şırnak",
};

export function normalizeProvince(name) {
  if (!name) return "";
  const raw = String(name).trim();
  const lower = raw.toLocaleLowerCase("tr");
  if (ALIASES[lower]) return ALIASES[lower];
  // Try exact match, case-insensitive
  const hit = TR_PROVINCES.find((p) => p.toLocaleLowerCase("tr") === lower);
  return hit || raw;
}
